/*
 * @Description:
 * @Author: zwcong
 * @Date: 2024-11-27 14:48:55
 * @LastEditors: zwcong
 * @LastEditTime: 2025-08-04 16:11:46
 */
/**
 * 公共配置
 */
/* eslint-disable global-require */
export default {
  // 日期格式化方式
  dateFormatLine: 'YYYY-MM-DD',
  // 重试
  retry: '重試',
  // 尾部是否显示邮箱
  showContactEmail: true,
  // 联系电话显示字符
  contactPhoneString: '',
  parent: '家長',
  stage3Null: '当前暂时无法进行预约，建议您直接进行在线诊断。',
  // 请输入邮箱
  emailPlaceholder: '請輸入郵箱',
  // 请输入正确的邮箱
  emailError: '請輸入正確的郵箱',
}
